<template>
  <div id="configs">
    <div
      id="content"
      class="content"
    >
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-cog"></i> Configuration des Weezys
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message type="is-primary">
          <i class="fal fa-info-circle"></i>
          Pour <strong>modifier</strong> les différentes entrées de la liste, sélectionnez un champ puis modifiez le.
          <br>
          Les configurations sont automatiquement ajoutées lors de la première connexion d'un Weezy.
          <br>
          Elles ne peuvent ni être ajoutées, ni être supprimées manuellement.
        </b-message>
      </div>
    </div>
    <div class="content">
      <configsTable
        id="configsTable"
        :weezys="weezys"
      />
    </div>
  </div>
</template>

<script>
import configsTable from "@/components/configsTable";
import _ from "lodash";

import http from "@/modules/request";
export default {
  name: "configs",
  components: {
    configsTable
  },
  data() {
    return {
      weezyId: "",
      goal_reload: "",
      users_reload: "",
      config_reload: "",
      boot_logo_1: "",
      boot_logo_2: "",
      weezys: []
    };
  },
  mounted() {
    this.getWeezys();
  },
  methods: {
    debounceNotif: _.debounce(async function(e) {
      this.succesToast("Configuration(s) modifiée(s) avec succés");
    }, 1000),

    getWeezys() {
      http
        .get("/weezys")
        .then(response => {
          var tempWeezys = response.data;
          for (var i = 0; i < tempWeezys.length; i++) {
            tempWeezys[i].goal_reload = tempWeezys[i].goal_reload / 1000;
            tempWeezys[i].users_reload = tempWeezys[i].users_reload / 1000;
            tempWeezys[i].config_reload = tempWeezys[i].config_reload / 1000;
          }
          this.weezys = tempWeezys;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    submitModify: function() {
      http
        .patch("/weezys/" + this.weezyId + "/config", {
          config: {
            goal_reload: this.goal_reload,
            users_reload: this.users_reload,
            config_reload: this.config_reload,
            boot_logo_1: this.boot_logo_1,
            boot_logo_2: this.boot_logo_2,
            weezy_id: this.weezy_id,
            game_sales_trigger: this.game_sales_trigger
          }
        })
        .then(
          function(response) {
            this.debounceNotif();
            this.getWeezys();
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec de modification");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    clearFields: function() {
      this.weezyId = "";
      this.goal_reload = "";
      this.users_reload = "";
      this.config_reload = "";
      this.boot_logo_1 = "";
      this.boot_logo_1 = "";
    },
    modifyRows(rows) {
      var count = rows.length;
      var modifiedArray = [];
      // From latest to oldest
      for (var i = 0; i < count; i++) {
        var modified = rows[count - i - 1];
        if (!modifiedArray.includes(modified.id)) {
          modifiedArray.push(modified.id);
          this.weezyId = modified.id;
          this.goal_reload =
            modified.goal_reload * 1000 > 15000
              ? modified.goal_reload * 1000
              : 15000; // SET MINIMUM TO 15seconds
          this.users_reload =
            modified.users_reload * 1000 > 60000
              ? modified.users_reload * 1000
              : 60000; // SET MINIMUM TO 60 seconds
          this.config_reload =
            modified.config_reload * 1000 > 60000
              ? modified.config_reload * 1000
              : 60000; // SET MINIMUM TO 60seconds
          this.game_sales_trigger = modified.game_sales_trigger;
          this.boot_logo_1 = modified.boot_logo_1;
          this.boot_logo_2 = modified.boot_logo_2;
          this.weezy_id = modified.weezy_id;
          this.submitModify();
        }
      }
    },
    errorToast(message) {
      this.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}
</style>